import { lifecycle } from 'recompose'
import { page } from 'utils/trackingUtils'

import MobileConfirmationStep from './component'

export default lifecycle({
  componentWillMount() {
    page('Onboarding Mobile Confirmation Setup')
  },
})(MobileConfirmationStep)



// WEBPACK FOOTER //
// ./src/layouts/MobileConfirmationStep/index.js